// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2COx1","header":"PatientQuestionnaire_header__vD-mH","info":"PatientQuestionnaire_info__1d42A"};